import { DomainEvent } from '../../../../core/domain/events/domain_event';
import { Transcription } from '../transcription';

export class TranscriptionEvent extends DomainEvent<Transcription> {}

export class TranscriptionCreated extends TranscriptionEvent {}

export class TranscriptionUpdated extends TranscriptionEvent {}

export class TranscriptionChanged extends TranscriptionEvent {}

export class TranscriptionDeleted extends TranscriptionEvent {}
